// Mirrors the `roles` DB table; source of truth for role indices.
//
// The labels users see come from roles.role_label and do NOT match these names:
//
//   Admin        (101) role "admin"         -> "Account Administrator"
//   AccountAdmin (102) role "account_admin" -> "Client Administrator"
//
// That reads backwards but is deliberate: 101 is internal staff who administer
// many ACCOUNTS (dfrakes@winsbyinc.com holds 38 clients), 102 is customer-side
// staff who administer one CLIENT. The short names are the misleading half, not
// the labels — and these keys mirror the short names because the backend does.
//
// Gate behaviour on the index. Never on the label, and never on the assumption
// that AccountAdmin means "Account Administrator".
export const RoleIndex = {
  Super: 100,
  Admin: 101,
  AccountAdmin: 102,
  ClientUser: 103,
} as const;

export type RoleName = typeof RoleIndex[keyof typeof RoleIndex];
